"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrapTypeahead = require("react-bootstrap-typeahead");

var _smartystreetsJavascriptSdk = require("smartystreets-javascript-sdk");

var _visuallyHidden = require("@react-aria/visually-hidden");

var _formatAddress = require("./helpers/formatAddress");

var _getGlobalFromWindow = _interopRequireDefault(require("../../../helpers/getGlobalFromWindow"));

var _iconCloseModal = _interopRequireDefault(require("../../../icons/icon-close-modal.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var autoCompleteClient;
var embeddedKey = (0, _getGlobalFromWindow["default"])('smartyEmbeddedKey');

if (embeddedKey) {
  var smartySharedCredentials = new _smartystreetsJavascriptSdk.core.SharedCredentials(embeddedKey);
  var autoCompleteClientBuilder = new _smartystreetsJavascriptSdk.core.ClientBuilder(smartySharedCredentials).withLicenses(['us-autocomplete-pro-cloud']);
  autoCompleteClient = autoCompleteClientBuilder.buildUsAutocompleteProClient();
}

var AddressTypeahead = function CustomAddressTypeaheadRenderer(_ref) {
  var storedValue = _ref.storedValue,
      isValid = _ref.isValid,
      complete = _ref.complete,
      fieldData = _ref.fieldData,
      eventHandler = _ref.eventHandler,
      isFocused = _ref.isFocused,
      onAddressSelected = _ref.onAddressSelected,
      lookupState = _ref.lookupState;
  var fieldCompleteAndValid = complete && isValid;
  var fieldCompleteAndInvalid = complete && !isValid;
  var wrapperClasses = (0, _classnames["default"])({
    'text-input-control__wrapper': true,
    'text-input-control__wrapper--focused': isFocused,
    'text-input-control__wrapper--error': fieldCompleteAndInvalid,
    'text-input-control__wrapper--valid': fieldCompleteAndValid
  });
  var errorId = "".concat(fieldData.id, "-error");

  var _useState = (0, _react.useState)(!!embeddedKey),
      _useState2 = _slicedToArray(_useState, 2),
      lookupEnabled = _useState2[0],
      setLookupEnabled = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      suggestions = _useState6[0],
      setSuggestions = _useState6[1];

  var _useState7 = (0, _react.useState)([storedValue]),
      _useState8 = _slicedToArray(_useState7, 2),
      selected = _useState8[0],
      setSelected = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      typeaheadIsOpen = _useState10[0],
      setTypeaheadIsOpen = _useState10[1];

  var _useState11 = (0, _react.useState)(),
      _useState12 = _slicedToArray(_useState11, 2),
      open = _useState12[0],
      setOpen = _useState12[1];

  var typeaheadRef = /*#__PURE__*/_react["default"].createRef();

  var handleSearch = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(query, filter) {
      var lookup, results;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (lookupEnabled) {
                _context.next = 3;
                break;
              }

              setOpen(false);
              return _context.abrupt("return");

            case 3:
              setIsLoading(true);
              eventHandler.onSearch(query);
              lookup = new _smartystreetsJavascriptSdk.usAutocompletePro.Lookup(query);
              lookup.maxResults = 10;
              lookup.selected = filter;

              if (lookupState) {
                lookup.includeOnlyStates = [lookupState];
              }

              _context.prev = 9;
              _context.next = 12;
              return autoCompleteClient.send(lookup);

            case 12:
              results = _context.sent;
              setSuggestions((0, _formatAddress.formatSuggestions)(results.result));

              if (filter) {
                setTimeout(function () {
                  return setSelected([query]);
                });
              }

              setIsLoading(false);
              _context.next = 24;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](9);
              // TODO: handle failures (ex: subscription overage)
              console.error(_context.t0);
              setLookupEnabled(false);
              setOpen(false);
              setIsLoading(false);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 18]]);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [lookupEnabled]);

  var handleChange = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(choice) {
      var _choice, suggestion, query, filter;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(choice.length === 0)) {
                _context2.next = 4;
                break;
              }

              setSelected(choice);

              if (lookupEnabled) {
                eventHandler.onChange(choice);
                setOpen(undefined);
              }

              return _context2.abrupt("return");

            case 4:
              _choice = _slicedToArray(choice, 1), suggestion = _choice[0].suggestion;

              if (!(suggestion.entries > 1)) {
                _context2.next = 14;
                break;
              }

              query = "".concat(suggestion.streetLine, " ").concat(suggestion.secondary);
              filter = (0, _formatAddress.formatSelected)(suggestion);
              setOpen(true);
              typeaheadRef.current.blur();
              typeaheadRef.current.focus();
              _context2.next = 13;
              return handleSearch(query, filter);

            case 13:
              return _context2.abrupt("return");

            case 14:
              setOpen(undefined);
              setSelected([suggestion.streetLine]);
              onAddressSelected(suggestion);
              typeaheadRef.current.blur();

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleChange(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleBlur = function handleBlur(event) {
    eventHandler.onBlur(event);
  };

  var handleFocus = function handleFocus() {
    if (lookupEnabled) {
      setOpen(undefined);
    } else {
      setOpen(false);
    }

    eventHandler.onFocus();
  };

  var getSearchQuery = function getSearchQuery() {
    return typeaheadRef.current ? typeaheadRef.current.state.text : '';
  };

  var buildMenuItem = function buildMenuItem(suggestion, label) {
    var searchQuery = getSearchQuery();

    if (suggestion.entries > 1) {
      var _getAddressParts = (0, _formatAddress.getAddressParts)(suggestion, false),
          street = _getAddressParts.street,
          secondary = _getAddressParts.secondary,
          entries = _getAddressParts.entries,
          city = _getAddressParts.city,
          state = _getAddressParts.state,
          zip = _getAddressParts.zip;

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "dropdown-menu__item"
      }, /*#__PURE__*/_react["default"].createElement(_reactBootstrapTypeahead.Highlighter, {
        search: searchQuery
      }, "".concat(street, " ").concat(secondary)), ' (', /*#__PURE__*/_react["default"].createElement("span", {
        className: "dropdown-menu__item--entries"
      }, entries), ")", /*#__PURE__*/_react["default"].createElement(_reactBootstrapTypeahead.Highlighter, {
        search: searchQuery
      }, "".concat(city, " ").concat(state, " ").concat(zip)));
    }

    return /*#__PURE__*/_react["default"].createElement(_reactBootstrapTypeahead.Highlighter, {
      search: searchQuery
    }, label);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, fieldData.instructions && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-input-control__instructions"
  }, fieldData.instructions), /*#__PURE__*/_react["default"].createElement("div", {
    className: "typeahead-input__wrapper ".concat(wrapperClasses)
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: fieldData.id,
    className: "text-input-control__label"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-input-control__label-text"
  }, fieldData.label)), typeaheadIsOpen && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "dropdown-menu__close-button",
    onClick: function onClick() {
      return typeaheadRef.current.hideMenu();
    }
  }, /*#__PURE__*/_react["default"].createElement(_visuallyHidden.VisuallyHidden, null, "Close"), /*#__PURE__*/_react["default"].createElement(_iconCloseModal["default"], {
    className: "dropdown-menu__close-icon"
  })), /*#__PURE__*/_react["default"].createElement(_reactBootstrapTypeahead.AsyncTypeahead, {
    ref: typeaheadRef,
    id: fieldData.id,
    useCache: false,
    open: open,
    delay: 350,
    selected: selected,
    "aria-describedby": errorId,
    isLoading: isLoading,
    onSearch: handleSearch,
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onMenuToggle: setTypeaheadIsOpen,
    options: suggestions,
    renderMenu: function renderMenu(results, menuProps) {
      var customMenuProps = _objectSpread(_objectSpread({}, menuProps), {}, {
        maxHeight: '12.5rem',
        style: _objectSpread(_objectSpread({}, menuProps.style), {}, {
          position: 'relative',
          transform: 'translate3d(0, 0, 0)'
        })
      });

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "dropdown-menu__wrapper"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "dropdown-menu__header"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Suggestions")), /*#__PURE__*/_react["default"].createElement(_reactBootstrapTypeahead.Menu, customMenuProps, results.map(function (result, index) {
        return /*#__PURE__*/_react["default"].createElement(_reactBootstrapTypeahead.MenuItem, {
          option: result,
          position: index,
          key: result.label
        }, buildMenuItem(result.suggestion, result.label));
      })));
    },
    inputProps: {
      className: 'text-input-control__input',
      id: fieldData.id,
      name: fieldData.fieldKey,
      autoComplete: fieldData.autocomplete,
      required: fieldData.validation.required
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    id: errorId,
    role: "alert",
    "aria-live": "assertive"
  }, fieldCompleteAndInvalid && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-input-control__error"
  }, fieldData.validation.message))));
};

AddressTypeahead.propTypes = {
  storedValue: _propTypes["default"].string.isRequired,
  isValid: _propTypes["default"].bool.isRequired,
  complete: _propTypes["default"].bool.isRequired,
  isFocused: _propTypes["default"].bool.isRequired,
  eventHandler: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    onBlur: _propTypes["default"].func.isRequired,
    onFocus: _propTypes["default"].func.isRequired,
    onUpdate: _propTypes["default"].func.isRequired,
    onSearch: _propTypes["default"].func.isRequired
  }).isRequired,
  fieldData: _propTypes["default"].shape({
    ariaDescribedBy: _propTypes["default"].string,
    id: _propTypes["default"].string.isRequired,
    fieldKey: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].string.isRequired,
      value: _propTypes["default"].string.isRequired
    })).isRequired,
    validation: _propTypes["default"].shape({
      message: _propTypes["default"].string.isRequired,
      pattern: _propTypes["default"].string.isRequired,
      required: _propTypes["default"].bool
    }).isRequired,
    value: _propTypes["default"].string.isRequired,
    autocomplete: _propTypes["default"].string.isRequired,
    instructions: _propTypes["default"].string,
    control: _propTypes["default"].shape({
      type: _propTypes["default"].string
    })
  }).isRequired,
  onAddressSelected: _propTypes["default"].func.isRequired,
  lookupState: _propTypes["default"].string.isRequired
};
var _default = AddressTypeahead;
exports["default"] = _default;